import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=0c65bb34"
import script from "./Icons.vue?vue&type=script&lang=ts"
export * from "./Icons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports